import { render, staticRenderFns } from "./CoCardMember.vue?vue&type=template&id=0fb7f848&scoped=true&"
import script from "./CoCardMember.vue?vue&type=script&lang=ts&"
export * from "./CoCardMember.vue?vue&type=script&lang=ts&"
import style0 from "./CoCardMember.vue?vue&type=style&index=0&id=0fb7f848&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb7f848",
  null
  
)

export default component.exports